import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { PwdStrength } from './use-pwd-strength';

interface PasswordStrengthProps {
  strength: PwdStrength;
}

const gray = 'secondary.main';
const red = 'error.main';
const blue = 'info.main';
const green = 'success.main';
const orange = '#c2410c';

export const PasswordStrength: React.FC<PasswordStrengthProps> = ({ strength }) => {
  const { t } = useTranslation();

  const PWD_STRENGTH_MAP = {
    [PwdStrength.NotSet]: { text: t('no_set'), lines: [gray, gray, gray, gray] },
    [PwdStrength.Weak]: { text: t('status_weak'), lines: [red, gray, gray, gray] },
    [PwdStrength.Fair]: { text: t('status_fair'), lines: [orange, orange, gray, gray] },
    [PwdStrength.Good]: { text: t('status_good'), lines: [blue, blue, blue, gray] },
    [PwdStrength.Strong]: { text: t('status_strong'), lines: [green, green, green, green] },
  };

  const item = PWD_STRENGTH_MAP[strength];

  return (
    <div>
      <Typography variant="body2" sx={{ fontSize: 12, fontWeight: 600 }} className="pb-2">
        {t('password_strength_label')}: {item.text}
      </Typography>

      <div className="flex gap-1">
        {item.lines.map((line, index) => (
          <Box
            key={index}
            className="h-1 w-1/4 rounded-sm"
            sx={{
              bgcolor: line,
              '@media (forced-colors: active)': {
                bgcolor: line === gray ? 'CaptionText' : 'highlight',
              },
            }}
          />
        ))}
      </div>
    </div>
  );
};
